<template>
  <v-container fluid>
    <v-data-table
      :headers="differenceInDestCountriesConfigTableHeaders"
      :items="filteredItems"
      class="elevation-1"
      :loading="loadingTable"
      hide-default-footer
      item-key="key"
      fixed-header
      :items-per-page="perPage"
      :page="page"
      disable-filtering
      disable-sort
      :item-class="getDifferenceInDestCountriesConfigFormattedItemClass"
    >
      <template v-slot:top>
        <v-toolbar
          class="toolbar"
          height="84"
          flat
        >
          <div class="d-flex align-center w-100">
            <v-spacer />
            <FilterInput
              v-model="filter"
              :items="differenceInDestCountriesConfigTableHeaders"
            />
          </div>
        </v-toolbar>

        <v-divider />
      </template>

      <template v-slot:item="{ item }">
        <tr
          v-for="(_item, _index) in item.records"
          :key="`${_index}_${_item.countryIso3}_${_item.currencyCode}_${_item.payoutType}_${_item.partnerProviderName}`"
          class="table__row"
        >
          <td class="row__item">
            {{ _item.countryIso3 }}
          </td>
          <td class="row__item">
            {{ _item.currencyCode }}
          </td>
          <td class="row__item">
            {{ _item.payoutType }}
          </td>
          <td class="row__item">
            {{ _item.partnerProviderName }}
          </td>
          <td class="row__item">
            {{ _item.statusName }}
          </td>
          <td class="row__item">
            {{ _item.comment }}
          </td>
        </tr>
        <tr class="table-divider" />
      </template>

      <template v-slot:no-data>
        <v-btn
          color="primary"
          dark
          @click="getDifferenceInDestCountriesConfig"
        >
          Refresh
        </v-btn>
      </template>

      <template v-slot:footer>
        <v-container
          fluid
          class="mt-4"
        >
          <v-row>
            <v-col
              cols="9"
              align-self="center"
            >
              <v-pagination
                v-model="page"
                class="b-pagination"
                :length="paginationLength"
                :total-visible="11"
                @input="onChangePage"
              />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="perPage"
                class="select-per-page"
                :items="perPageItems"
                placeholder="Items per page"
                dance
                @change="perPage = parseInt($event, 10)"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import {differenceInDestCountriesConfigTableHeaders} from "@/utils/staticTablesColumns";
import FilterInput from "../FilterInput";

export default {
  name: "DifferenceInDestCountriesConfig",
  components: {
    FilterInput,
  },
  data() {
    return {
      loadingTable: false,
      page: 1,
      perPage: 10,
      perPageItems: [10, 25, 50, 100, 500],
      filter: []
    }
  },
  watch: {
    perPage(newValue) {
      this.addHashToLocation("perPage", newValue);
    },
    filterStringURL(newValue) {
      this.page = 1;
      this.addHashToLocation("page", 1);
      this.addHashToLocation("filter", newValue);
    }
  },
  computed: {
    ...mapGetters({
      differenceInDestCountriesConfig: "AnalyzerStore/differenceInDestCountriesConfig",
    }),
    paginationLength() {
      return Math.ceil(this.filteredItems?.length / this.perPage) || 1;
    },
    filteredItems () {
      if (!this.filter?.length) {
        return this.differenceInDestCountriesConfig;
      }

      return this.differenceInDestCountriesConfig.filter(item => {
        let isFilter = true;

        item.records.forEach(record => {
          this.filter.forEach((_item) => {
            isFilter = isFilter && record[_item.key]?.toLowerCase() === _item.value?.toLowerCase();
          });
        })

        return isFilter;
      })
    },
    filterStringURL: {
      get() {
        return this.filter.map(item => {
          return `${item.key}:${item.value}:${item.name}`;
        }).join(",");
      },
      set(newValue) {
        const filterArray = newValue.split(",");
        filterArray.forEach((item, index) => {
          const filterKeyValue = item.split(":")

          const filterItem = {
            key: filterKeyValue[0],
            value: filterKeyValue[1],
            name: filterKeyValue[2],
          };

          this.$set(this.filter, index, filterItem);
        });

        return newValue;
      }
    }
  },
  async created() {
    this.differenceInDestCountriesConfigTableHeaders = differenceInDestCountriesConfigTableHeaders;

    await this.getDifferenceInDestCountriesConfig();

    this.restorePageFromQuery();
  },
  methods: {
    async getDifferenceInDestCountriesConfig() {
      try {
        this.loadingTable = true;

        await this.$store
            .dispatch("AnalyzerStore/getDifferenceInDestCountriesConfig");
      } finally {
        this.loadingTable = false;
      }
    },
    restorePageFromQuery() {
      if (!this.$route.query) {
        return;
      }

      const query = this.$route.query;

      if (query?.page) {
        this.page = Number(query.page);
      }

      if (query?.perPage) {
        this.perPage = Number(query.perPage);
      }

      if (query?.filter) {
        this.filterStringURL = decodeURIComponent(query.filter);
      }
    },
    getDifferenceInDestCountriesConfigFormattedItemClass(item) {
      if (!item.onlyOne) {
        return 'not-only-one';
      }

      return '';
    },
    onChangePage() {
      this.addHashToLocation("page", this.page);
    },
    addHashToLocation(key, value) {
      const url = new URL(window.location);
      url.searchParams.set(key, encodeURIComponent(value));
      window.history.pushState({}, '', url);
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .v-data-table__wrapper {
  table {
    border-collapse: collapse;

    .table-divider {
      border-bottom: thin solid rgba(0, 0, 0, 0.12);
    }

    .table__row {
      .row {
        &__item {
          border: none !important;
        }
      }
    }
  }
}
</style>